/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import gql from "graphql-tag";
import { User } from "../../../graphql/user";

export interface UsersData {
  users: User;
}

export const usersByEmail = gql`
  query ($email: String!) {
    users: usersByEmail(email: $email) {
      id
      name
      email
      discountCode
      tosApproved
      tosVersion
      created
      updated
      platform
      address {
        line1
        line2
        city
        state
        zip
        country
      }
      organizations {
        id
        name
        status
        role
        created
        updated
        disabled
        lastLogin
      }
    }
  }
`;

export const removeUser = gql`
  mutation ($userId: ID!) {
    status: removeUser(userId: $userId)
  }
`;

export const organizationsByName = gql`
  query ($name: String!) {
    orgs: organizationsByName(name: $name) {
      id
      name
      plan
      platform
      planInfo {
        plan
        price
        accounts
        apps
        uploads
        expire
      }
      address {
        line1
        line2
        city
        state
        zip
        country
        telephone1
        telephone2
      }
      notes {
        id
        text
        created
        createdBy
        updated
        updatedBy
      }
      created
      updated
      maxUsers
      maxAdminUsers
      maxApplicationsPerPlatform
      maxUploadsPerMonthPerApp
      buildArchiveExpiration
      planExpires
      trialStarted
      trialExpires
    }
  }
`;

export const organizationsByDomain = gql`
  query ($name: String!) {
    orgs: organizationsByDomain(domain: $name) {
      id
      name
      plan
      platform
      planInfo {
        plan
        price
        accounts
        apps
        uploads
        expire
      }
      address {
        line1
        line2
        city
        state
        zip
        country
        telephone1
        telephone2
      }
      created
      updated
      maxUsers
      maxAdminUsers
      maxApplicationsPerPlatform
      maxUploadsPerMonthPerApp
      buildArchiveExpiration
      planExpires
      trialStarted
    }
  }
`;

export const createOrganization = gql`
  mutation CreateOrganization($organization: OrganizationCreateInput!) {
    createOrganization(organization: $organization) {
      id
    }
  }
`;

export const updateOrganization = gql`
  mutation UpdateOrganization($organization: OrganizationInput!) {
    updateOrganization(organization: $organization) {
      id
    }
  }
`;

export const removeOrganization = gql`
  mutation ($orgId: ID!) {
    status: removeOrganization(orgId: $orgId)
  }
`;

export const reportStatistics = gql`
  query ($options: ReportInput!) {
    res: reportStatistics(options: $options) {
      reportType
      start
      end
      result
    }
  }
`;

export const updateOrganizationNote = gql`
  mutation UpdateOrganizationNote(
    $orgId: ID!
    $noteId: String
    $noteText: String
  ) {
    updateOrganizationNote(
      orgId: $orgId
      noteId: $noteId
      noteText: $noteText
    ) {
      id
    }
  }
`;
